import React from "react";
import styled from "styled-components";
import { FaFacebook, FaYoutube, FaInstagram } from "react-icons/fa";
import { BsFillTelephoneFill } from "react-icons/bs";
import { FiMail } from "react-icons/fi";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <Container>
      <Up>
        <Wrap>
          <Section width="26%">
            <Link to="/"> {/* Link added here */}
              <img src="logo.jpg" alt="Ibex Filmz Logo" />
            </Link>
            <h2>Ibex Filmz</h2>
            <p>No: 468, 4th Floor,</p>
            <p>Jana Jaya City Mall ( JJC MALL ),</p>
            <p>Rajagiriya, Sri Lanka</p>
          </Section>

          <Section width="34%">
            <p className="heading">Our Services</p>
            <h4>Product Commercial</h4>
            <h4>Corporate</h4>
            <h4></h4>
            <h4>Real Estate </h4>
            <h4>Documentaries</h4>
            <h4>Destination Promotions</h4>
            <h4>Aerial Cinematography</h4>
            <h4>Action Sports</h4>
          </Section>

          <Section_Middle width="22%">
            <p className="heading">Support</p>
            <Link to="/" className="footer-link">
              <h4>Home</h4>
            </Link>
            <Link to="/services" className="footer-link">
              <h4>Services</h4>
            </Link>
            <Link to="/about" className="footer-link">
              <h4>About Us</h4>
            </Link>
            <Link to="/works" className="footer-link">
              <h4>Our Works</h4>
            </Link>
            <Link to="/contact" className="footer-link">
              <h4>Contact Us</h4>
            </Link>
          </Section_Middle>

          <Section width="18%">
            <p className="heading">Contacts</p>
            <a href="tel:+94710877777" className="contact-link">
              <BsFillTelephoneFill className="icons_footer" />
              <p>(+94) 71 087 7777</p>
            </a>
            <a href="mailto:info@ibexfilmz.com" className="contact-link">
              <FiMail className="icons_footer" />
              <p>info@ibexfilmz.com</p>
            </a>
          </Section>
        </Wrap>
      </Up>

      <Down>
        <Folder>
          <p>All Rights Reserved 2024 Ibex Filmz</p>
          <p>
            Designed and Developed by
            <a href="https://ceriture.com/" className="heading">
              {" "}
              Ceriture
            </a>
          </p>
        </Folder>
      </Down>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  overflow: hidden;
  margin-bottom:2vh;
`;

const Up = styled.div`
  width: 100%;
  min-height: 43vh;
  background: var(--primary-color);
  display: flex;
  justify-content: center;
`;

const Down = styled.div`
  width: 100%;
  height: 14vh;
  background: var(--primary-color);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Wrap = styled.div`
  width: 95%;
  height: 100%;
  display: flex;
  border-top: 2px solid var(--secondary-color);
  border-radius: 15px;
  padding: 0 100px;

  @media only screen and (max-width: 1200px) {
    flex-direction: column;
    padding: 20px 0;
  }
`;

const Section = styled.div`
  width: ${(props) => props.width};
  height: 100%;
  padding: 40px 0;

  @media only screen and (max-width: 1200px) {
    width: 100%;
    text-align: center;
    height: 50%;
    display: flex;
    flex-direction: column; /* Align content vertically */
    align-items: center; /* Center items horizontally */
  }

  .heading {
    color: var(--secondary-color);
  }

  p,
  h4 {
    color: #fff;
    font-size: 12px;
    padding-top: 9px;
  }

  h2 {
    color: white;
  }

  img {
    width: 23%;
    border-radius: 15%;
    margin-bottom: 10px;

    @media only screen and (max-width: 1200px) {
      display: none;
    }
  }

  .icons_footer {
    color: #fff;
    font-size: 20px;
    margin-right: 8px;
  }

  .footer-link {
    text-decoration: none;
    color: #fff;
    margin: 10px 0;

    &:hover {
      color: var(--secondary-color);
    }
  }

  .contact-link {
    display: flex;
    align-items: center;
    color: white; /* Ensure text is white */
    text-decoration: none; /* Remove underline */
    margin: 8px 0;

    &:hover {
      color: var(--secondary-color);
    }

    .icons_footer {
      color: white;
      margin-right: 10px;
    }

    span {
      color: white; /* Ensure span text color is white */
      font-size: 14px; /* Adjust font size if necessary */
    }
  }
`;

const Section_Middle = styled(Section)`
  @media only screen and (max-width: 1200px) {
    display: none;
  }
`;

const Folder = styled.div`
  width: 30%;
  padding: 10px 0;
  border-top: 2px solid var(--secondary-color);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .heading {
    color: var(--secondary-color);
  }

  p {
    font-size: 13px;
    margin-top: 10px;
    text-align: center;
    color: #fff;
  }

  a {
    font-size: 15px;
    text-align: center;
    color: white; /* Ensures text color for links in Folder */
    text-decoration: none;

    &:hover {
      color: var(--secondary-color);
    }
  }
`;

export default Footer;
